import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box } from '@mui/material';
import { useStyles } from '../styles';
import NavigationDropdown, { NavigationOption } from 'modules/views/shared/NavigationDropdown';

export const MyProfileHeader: React.FC = () => {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <Box className={classes.header} data-testid="my-profile-header">
      <p className={classes.title} data-testid="my-profile-title">
        {t('myProfile.title')}
      </p>
      <NavigationDropdown excludeOptions={[NavigationOption.MY_PROFILE]} />
    </Box>
  );
};
